import { SET_SCROLL_CONTAINER_POSITION, SHOW_SCREEN, } from '../constants/actionTypes';
import { getCurrentScale } from '../selectors';
export var scrollPositions = {};
export var scrollPositionMiddleware = function (store) { return function (next) { return function (action) {
    if (action.type === SHOW_SCREEN) {
        var scrollContainers = document.querySelectorAll('[data-layer-type="scrollContainer"]');
        if (!scrollContainers.length) {
            return next(action);
        }
        var scaleFunc = getCurrentScale(store.getState());
        var scale_1 = scaleFunc(1000000) / 1000000;
        scrollContainers.forEach(function (el) {
            scrollPositions[el.dataset.layerId] = [
                el.scrollLeft / scale_1,
                el.scrollTop / scale_1,
            ];
        });
        store.dispatch({ type: SET_SCROLL_CONTAINER_POSITION, scrollPositions: scrollPositions });
    }
    return next(action);
}; }; };
